import './style.scss';
import '../style.scss';
import { Button, ButtonProps, ButtonSize, FillType } from 'views/components/atoms/button';
import { ComfirmGroup } from 'views/utils/accountEstablish';
import { EstablishHeader } from 'views/components/atoms/establishes/header';
import { Gauge, GaugeSP, getGaugeValue } from 'views/components/atoms/gauge';
import { useLocation } from 'react-router-dom';

type CustomerInfoTemplateType = {
  isUpdate: boolean;
  comfirmGroup: ComfirmGroup[];
  buttonProps?: {
    nextButtonProps: ButtonProps;
    prevButtonProps: ButtonProps;
  };
};

export const RequestConfirmTemplate = ({ isUpdate, comfirmGroup, buttonProps }: CustomerInfoTemplateType) => {
  const location = useLocation();

  return (
    <div className={`establishWrapper ${isUpdate ? '' : 'establishConfirm'}`}>
      <GaugeSP currentPage={getGaugeValue(location.pathname)} />
      {isUpdate && (
        <div className="lastConfirm">
          <span className="lastConfirm_label">
            まだ更新は実施されていません。画面をスクロールして「登録情報を更新する」ボタンを押下してください
          </span>
        </div>
      )}
      {comfirmGroup.map((item, i) => {
        return (
          <div key={i} className="confirm">
            <div className="confirm_header">
              <span className="confirm_header_title">{item.header}</span>
              <Button
                onClick={item.onClick}
                label="修正"
                fillType={FillType.dangerEmpty}
                buttonSize={ButtonSize.sizeXS}
              />
            </div>
            {item.dispList.map((data, index) => {
              return (
                <>
                  {data.visible && (
                    <div className="confirm_answer" key={index}>
                      <EstablishHeader headerTitle={data.title} />
                      <span className="confirm_answer_label">
                        {Array.isArray(data.value) ? data.value.map((v) => v) : data.value}
                      </span>
                    </div>
                  )}
                </>
              );
            })}
          </div>
        );
      })}
      <div className="lastConfirm">
        <a
          href={process.env.REACT_APP_PURPOSE_OF_USE_OF_PERSONAL_INFORMATION_URL}
          target="_blank"
          rel="noreferrer noopener"
        >
          <span className="lastConfirm_link">個人情報の利用目的についてはこちらからご確認ください</span>
        </a>

        <span className="lastConfirm_label">
          上記内容を確認の上、証券取引口座の設定、保護預かり口座の設定、電子交付サービスおよび振込先指定方式サービスを申し込みます
        </span>
      </div>
      {buttonProps && (
        <div className="establishWrapper">
          <div className="establishWrapper_buttons">
            <Button {...buttonProps.prevButtonProps} />
            <Button {...buttonProps.nextButtonProps} />
          </div>
        </div>
      )}
    </div>
  );
};
